<div class="flex gap-1 items-center">
  <span class="text-proffeo-muted text-sm">{{ 'task-details-modal-created-task' | translate }}</span>
</div>
